"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Download } from "lucide-react";

const reports = [
  { label: "User Activity", description: "Monthly user engagement report" },
  { label: "Content Moderation", description: "Moderation actions and trends" },
  { label: "Learning Progress", description: "Course completion and certification stats" },
  { label: "Event Attendance", description: "Event registration and attendance data" },
  { label: "Community Growth", description: "Community membership and activity trends" },
  { label: "System Health", description: "Platform performance and uptime" },
];

export default function ReportsPage() {
  return (
    <div className="space-y-6">
      <h1 className="font-heading text-xl font-semibold tracking-tight text-foreground">Reports</h1>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {reports.map((report) => (
          <Card key={report.label}>
            <CardContent className="p-5">
              <div className="flex items-center gap-3">
                <div className="rounded-lg bg-muted/10 p-2 shrink-0">
                  <FileText className="h-5 w-5 text-muted-foreground" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground">{report.label}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{report.description}</p>
                </div>
              </div>
              <Button variant="outline" size="sm" className="mt-4 w-full">
                <Download className="mr-2 h-4 w-4" /> Generate Report
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
